var ctFlexitimeModel;
(function ($) {
 	$.fn.capitechFlexitime = function(options) {
		
		var $ctFlexitimeElm = $(this);
		
		// functions
		/*////////////////////////////////////////////////////////////*/
		function init() {
			getFlexitime();
		}
		
		function getFlexitime() {
			var currentDate = new Date();
			var success = function success(data, textStatus, jqXHR) {
				var modelData = {};
				loaderIndicator(false);
				if (data.success == true) {
					modelData.flexitime = data.content;
					ctFlexitimeModel = ko.viewmodel.fromModel(modelData);
					$('*[data-ko-bind="ctFlexitimeModel"]').each(function(index, obj) {
						ko.applyBindings(ctFlexitimeModel, obj);
					});
				} else {
					sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
				}
			};
			var error = function error(jqXHR, textStatus, errorThrown) {
				loaderIndicator(false);
				sweetAlert("Error", errorThrown, "error");
			};
			loaderIndicator(true);
			_api.getFlexiTimeTransactions_POST(success, error, getCookie(ACCESSTOKEN_COOKIE_NAME), currentDate.getFullYear());
		}
		
		// init
		/*////////////////////////////////////////////////////////////*/
		init();
		
	};
}(jQuery));